import ActionTypes from '../Actions/ActionTypes';

let initialState = {
  isLogin: false,
  user: null,
  themeColor: "#ED73AA",
  fontFamily: "'Poppins', sans-serif",
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.IsLogin:
      state = { ...state, isLogin: action.payload };
      break;

    case ActionTypes.GET_USER:
      state = { ...state, user: action.payload };
      break;

    case ActionTypes.IsLogout:
      state = { user: null, isLogin: false };
      break;

    case ActionTypes.ChangeThemeColor:
      state = { ...state, themeColor: action.payload };
      break;
    case ActionTypes.ChangeThemeFont:
      state = { ...state, fontFamily: action.payload };
      break;

    case ActionTypes.UpdateUserProfile:
      state = { ...state, user: { ...state.user, user: action.payload } };
      break;
    case ActionTypes.NotificationSwitch:
      state = {
        ...state,
        user: { ...state.user, is_receive_notification: action.payload },
      };
      localStorage.setItem("@user", JSON.stringify(state.user));
      break;


    default:
      break;
  }
  return state;
};

export default AuthReducer;
